import React, { useState, useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import Select from "react-select";
import loadingGif from "../loading.gif";
import ImagenMapa from "../mapa.png";
import RedProvFormularioModal from "./RedProvFormularioModal";

import {
  MapPin,
  Trash2,
  Building2,
  Globe,
  Phone,
  Landmark,
  Layers,
  Tag,
  Star,
  Search,
  ArrowLeft,
  Info,
  HelpCircle,
  Filter,
  X,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import {
  Container,
  Row,
  Col,
  Spinner,
  Form,
  Modal,
  Card,
  Button,
  Pagination,
  Collapse,
  Table,
  InputGroup,
} from "react-bootstrap";
import {
  CardBody,
  CardImg,
  CardTitle,
  CardText,
  CardHeader,
  CardFooter,
} from "reactstrap";
import axiosSomit from "../axios-config";
import apiClient from "../RedProveedores/apiClient";
import Farmacias from "./Farmacias";
import { useIdioma } from "../context/IdiomaContext";
const RedProveedores = ({ datosramos }) => {
  const { t } = useIdioma();
  /* aqui se crean los componentes de estado, lo que significa que el componente categoría se llenará cuando se llame el metdod setCategoria y se inicializa con el
  valor vacio
  */
  const [categoria, setCategoria] = useState("");
  const [busqueda, setBusqueda] = useState("");
  const categoriasScrollRef = useRef(null);
  const scrollCategorias = (direction) => {
    if (categoriasScrollRef.current) {
      const scrollAmount = 300;
      categoriasScrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth"
      });
    }
  };
  const [CatSel, setCatSel] = useState("");
  const [especialidad, setEspecialidad] = useState("");
  const [mostrarOpcionales, setMostrarOpcionales] = useState(false);
  const [selectedProveedor, setSelectedProveedor] = useState(null);
  const [pais, setPais] = useState(null);
  const [departamento, setDepartamento] = useState(null);
  const [municipio, setMunicipio] = useState(null);
  const [zona, setZona] = useState(null);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [paginaActual, setPaginaActual] = useState(1);
  const [categorias, setCategorias] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [paises, setPaises] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [zonas, setZonas] = useState([]);

  const [proveedores, setProveedores] = useState([]);
  const [lstFarmacias, setLstFarmacias] = useState([]);
  const registrosPorPagina = 10;

  const [loading, setLoading] = useState(false);
  const [mostrarModal, setMostrarModal] = useState(false);
  const cerrarModalFom = () => {
    setMostrarModal(false);
  };

  const quitarFiltros = () => {
    setCategoria(0);
    setEspecialidad(null);
    // setPais(null);
    setBusqueda("");
    setCatSel(null);
    //setDepartamentos([]);
    //setMunicipios([]);
    //setZonas([]);
    setDepartamento(null);
    setMunicipio(null);
    setZona(null);
    cargarProveedores("", null, null, null, null, null, null, null);
  };

  // funcion genérica que se utiliza para consultar los proveedores aplicando cualquier filtero
  const cargarProveedores = async (
    pagina,
    categoria,
    especialidad,
    pais,
    departamento,
    municipio,
    zona,
    busqueda
  ) => {
    // este codigo para cuando cambien categoría apliquen un filtro oculte la ventana de detalles
    if (selectedProveedor) {
      setSelectedProveedor(null);
    }
    if (!loading) {
      setLoading(true);
    }


    let parametros = "";
    if (pagina) {
      parametros += `page=${pagina == 0 ? 0 : pagina}`;
      parametros += "&aseguradora=" + sessionStorage.getItem("codigoAseguradora");
    } else {
      parametros += "aseguradora=" + sessionStorage.getItem("codigoAseguradora");
    }



    if (busqueda) {
      parametros += `&search=${busqueda}`;
    }
    if (categoria) {
      parametros += `&category=${categoria}`;
    }
    if (especialidad) {
      parametros += `&speciality=${especialidad}`;
    }
    if (pais) {
      parametros += `&country=${pais.id}`;
    }
    if (departamento) {
      parametros += `&department=${departamento.id}`;
    }
    if (municipio) {
      parametros += `&municipality=${municipio.id}`;
    }

    if (zona) {
      parametros += `&zone=${zona.id}`;
    }

    /*if (
      categoria == 10 ||
      categoria == 20 ||
      categoria == 30 ||
      categoria == 40 ||
      categoria == 50 ||
      categoria == 60 ||
      categoria == 70
    ) {
      if (zona) {
        parametros += `&zone=${zona.name}`;
      }
      /*
          10	Hospitales ciudad de Guatemala
          20	Hospitales departamentales
          30	Centros integrales Cdad. Guatemala
          40	Farmacias
          50  OTRO
          60  OTRO
          70  OTRO
        
      if (categoria == 40) {
        // farmacias
        axiosSomit
          .get(
            `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/getListaFarmacias`,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
              },
            }
          )
          .then((respuesta) => {
            if (respuesta.status === 200) {
              setLstFarmacias(
                respuesta.data.content.farmacias
                  ? respuesta.data.content.farmacias
                  : []
              );
              setPaginaActual(pagina ? pagina : 1);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        let respuestaApi = null;
        axiosSomit
          .get(
            `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/getListaProveedores?` +
              parametros,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
              },
            }
          )
          .then((respuesta) => {
            if (respuesta.status === 200) {
              respuestaApi = respuesta.data.content.providers
                ? respuesta.data.content.providers
                : [];
              setProveedores(respuestaApi);
              setTotalRegistros(respuesta.data.content.pages.total * 10);
              setPaginaActual(pagina ? pagina : 1);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      }
    } else {
      // manejamos aqui la zona porque para api de la general se utiliza el id y para el api de somit el nombre
      if (zona) {
        parametros += `&zone=${zona.id}`;
      }*/
     console.log(datosramos);
    let url =
      `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/providers?idCertificado=${datosramos[0].certi}&idPoliza=${datosramos[0].datosPoliza.idPoliza.idPoliza}&` + parametros;

    let respuestaApi = null;
    axiosSomit
      .get(url, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
        },
      })
      .then((respuesta) => {
        //console.log("RESPUESTA:  ",respuesta);
        if (respuesta.data.content && respuesta.data.content.farmacias) {
          setLstFarmacias(
            respuesta.data.content.farmacias
              ? respuesta.data.content.farmacias
              : [],
          );
        } else if (respuesta.data.content) {
          respuestaApi = respuesta.data.content.providers
            ? respuesta.data.content.providers
            : [];
          setProveedores(respuestaApi);
          setTotalRegistros(respuesta.data.content.pages.total * 10);

          setPaginaActual(pagina ? pagina : 1);
        } else {

          setProveedores([]);
          setTotalRegistros(0);
          setPaginaActual(1);
        }
      })
      .catch(function (error) {
        console.error("Error al obtener los proveedores:", error.message);
      })
      .finally(() => {
        // esta validación se coloco inicialmente para cuando no encuentre registro se muestra un formulario
        // pero luego se comento porque en la pantalla se colocó una opción para acceder al msimo formulario
        // con el mensaje Necesitas ayuda para encontrar a tu proveedor? presiona aquí
        if (respuestaApi?.length === 0) {
          /* se comenta porque ahora ya o se muestra en automático si no que se tienen un botón
              if (sessionStorage.getItem("mostrarFormularioCita") == 1) {
                setMostrarModal(true);
              }
          */
        }
        setLoading(false);
      });
    //}
  };

  const totalPaginas = Math.ceil(totalRegistros / registrosPorPagina);
  const renderPaginacion = () => {
    const cambiarPagina = (nuevaPagina) => {
      cargarProveedores(nuevaPagina, categoria, especialidad, pais, departamento, municipio, zona, busqueda);
    };

    return (
      <div className="d-flex justify-content-center align-items-center mt-4 gap-2">
        <button
          className="btn btn-outline-secondary"
          onClick={() => cambiarPagina(paginaActual - 1)}
          disabled={paginaActual === 1}
          style={{ width: "40px", height: "40px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px" }}
        >
          &lt;
        </button>

        <div style={{ width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgb(0, 52, 121)", color: "white", borderRadius: "8px", fontWeight: "bold" }}>
          {paginaActual}
        </div>

        <span style={{ margin: "0 10px", color: "#6c757d" }}>de {totalPaginas}</span>

        <button
          className="btn btn-outline-secondary"
          onClick={() => cambiarPagina(paginaActual + 1)}
          disabled={paginaActual === totalPaginas}
          style={{ width: "40px", height: "40px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px" }}
        >
          &gt;
        </button>
      </div>
    );
  };

  const irAUbicacion = (latitud, longitud) => {
    const url = `https://www.google.com/maps/dir/Current+Location/${latitud},${longitud}`;
    window.open(url, "_blank");
  };

  const MapaEstatico = ({ latitud, longitud, zoom = 15 }) => {
    const googleMapsUrl = `https://www.google.com/maps/dir/Current+Location/${latitud},${longitud}`;

    return (
      <a href={googleMapsUrl} target="_blank">
        <img
          src={ImagenMapa}
          alt="Ubicación"
          style={{
            width: "55%",
            height: "auto",
            cursor: "pointer",
            marginTop: "30px",
            borderRadius: "8px",
          }}
        />
      </a>
    );
  };

  useEffect(() => {
    //aqui va a traer las categorias de la aseguradora general
    // laboratorios, Médicos, Centros De Diagnóstico
    const categoriasIncluidas = [2, 3, 5];
    setLoading(true);
    axiosSomit
      .get(`${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/categories?aseguradora=${sessionStorage.getItem("codigoAseguradora")}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
        },
      })
      .then((respuesta) => {
        /*console.log("respuesta: ",respuesta);
        const categoriasFiltradas = respuesta.data.categories.filter(
          (c) => categoriasIncluidas.includes(c.id)
        );*/
        setCategorias(respuesta.data.categories);

        /*//aqui va a traer las categorias que tenemos registrados en somit
        axiosSomit
          .get(
            `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/getListaTipoProv`,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
              },
            }
          )
          .then((respuestaSomit) => {
            if (respuestaSomit.status === 200) {
              setCategorias((prev) => [
                ...prev,
                ...respuestaSomit.data.content.categories,
              ]);
            }
          });*/
      });

    axiosSomit
      .get(`${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/specialities?aseguradora=${sessionStorage.getItem("codigoAseguradora")}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
        },
      })
      .then((respuesta) => {
        //console.log("Respuesta specialities: ", respuesta);
        setEspecialidades(respuesta.data.content.specialities);
        setLoading(false);
      });
    //voy a consultar la lista de paises y filtarar que solo muestre el pais 1 que es guatemala
    axiosSomit
      .get(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/countries?aseguradora=${sessionStorage.getItem("codigoAseguradora")}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        }
      )
      .then((respuesta) => {
        //console.log("Respuesta paices: ", respuesta);
        if (respuesta.data.content.countries) {
          /*const paisesFiltradas = respuesta.data.content.countries.filter(
            (c) => c.id == 1,
          );*/
          setPaises(respuesta.data.content.countries);
          setTimeout(() => {
            const guatemala = respuesta.data.content.countries.find(
              (pais) => pais.name.toLowerCase() === "guatemala"
            );

            if (guatemala) {
              const paisSeleccionado = {
                value: guatemala.id,
                label: guatemala.name,
                ...guatemala,
              };
              setPais(paisSeleccionado);
            }
          }, 500);
        }
      });
  }, []);

  useEffect(() => {
    if (pais) {
      setLoading(true);
      setDepartamento(null);
      setDepartamentos([]);
      setMunicipios([]);
      setMunicipio(null);
      setZona(null);
      setZonas([]);
      axiosSomit
        .get(
          `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/countries/` +
          pais.id +
          "/departments?aseguradora=" + sessionStorage.getItem("codigoAseguradora"), {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
          },
        }
        )
        .then((respuesta) => {
          //console.log("Respuesta depto: ",respuesta);
          setLoading(false);
          setDepartamentos(
            respuesta.data.content.departments
              ? respuesta.data.content.departments
              : []
          );
        });

      setMunicipio(null);
      setZona(null);
    }
  }, [pais]);

  useEffect(() => {
    if (departamento) {
      setMunicipios([]);
      setMunicipio(null);
      setZona(null);
      setZonas([]);
      setLoading(true);
      axiosSomit
        .get(
          `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/countries/` +
          pais?.id +
          "/departments/" +
          departamento?.id +
          "/municipalities?aseguradora=" + sessionStorage.getItem("codigoAseguradora"),
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
            },
          }
        )
        .then((respuesta) => {
          //setLoading(false);
          setMunicipios(
            respuesta.data.content.municipalities
              ? respuesta.data.content.municipalities
              : []
          );
          cargarProveedores(
            paginaActual,
            categoria,
            especialidad,
            pais,
            departamento,
            municipio,
            zona,
            busqueda,
          )
        });

      setZona(null);
    }
  }, [departamento]);

  useEffect(() => {
    if (municipio) {
      setLoading(true);
      setZonas([]);
      setZona(null);
      axiosSomit
        .get(
          `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/countries/` +
          pais?.id +
          "/departments/" +
          departamento?.id +
          "/municipalities/" +
          municipio?.id +
          "/zones?aseguradora=" + sessionStorage.getItem("codigoAseguradora"),
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
            },
          }
        )
        .then((respuesta) => {
          //setLoading(false);
          setZonas(
            respuesta.data.content.zones ? respuesta.data.content.zones : []
          );
          cargarProveedores(
            paginaActual,
            categoria,
            especialidad,
            pais,
            departamento,
            municipio,
            zona,
            busqueda,
          );
        });
    }
  }, [municipio]);
  var opcionesEspecialidad = undefined;
  if (especialidades) {
    opcionesEspecialidad = especialidades.map((esp) => ({
      value: esp.id,
      label: esp.name,
    }));
  }

  const normalizarId = (valor) => {
    if (valor === null || valor === undefined) {
      return null;
    }

    const id = typeof valor === "object"
      ? valor.id ?? valor.value ?? valor.category ?? valor.codigo
      : valor;

    return id === null || id === undefined ? null : String(id);
  };

  const esValorActivo = (valor) => valor === true || valor === 1 || valor === "1" || valor === "true";

  const obtenerCategoriaProveedor = (proveedor) => {
    const categoriaProveedor = proveedor?.category;

    if (categoriaProveedor && typeof categoriaProveedor === "object") {
      const categoriaCatalogo = categorias.find((cat) => normalizarId(cat.id) === normalizarId(categoriaProveedor));
      return { ...categoriaProveedor, ...categoriaCatalogo };
    }

    return categorias.find((cat) => normalizarId(cat.id) === normalizarId(categoriaProveedor));
  };

  const obtenerNombreCategoriaProveedor = (proveedor) => {
    const categoriaProveedor = proveedor?.category;
    const categoriaResuelta = obtenerCategoriaProveedor(proveedor);

    if (categoriaResuelta?.name) {
      return categoriaResuelta.name;
    }

    if (categoriaProveedor?.name) {
      return categoriaProveedor.name;
    }

    if (CatSel?.name) {
      return CatSel.name;
    }

    return typeof categoriaProveedor === "object" ? categoriaProveedor.name : "";
  };

  const obtenerNombreEspecialidadProveedor = (proveedor) => {
    const especialidadProveedor = [
      proveedor?.specialityName,
      proveedor?.speciality_name,
      proveedor?.specialtyName,
      proveedor?.specialty_name,
      proveedor?.speciality,
      proveedor?.specialty,
      proveedor?.specialities,
      proveedor?.specialties,
      proveedor?.speciality_id,
      proveedor?.specialty_id,
    ].find((valor) => {
      if (Array.isArray(valor)) {
        return valor.length > 0;
      }

      return valor !== null && valor !== undefined && valor !== "";
    });

    if (especialidadProveedor === null || especialidadProveedor === undefined || especialidadProveedor === "") {
      return "";
    }

    if (Array.isArray(especialidadProveedor)) {
      return especialidadProveedor
        .map((esp) => typeof esp === "object" ? esp.name ?? esp.label ?? "" : String(esp))
        .filter(Boolean)
        .join(", ");
    }

    if (typeof especialidadProveedor === "object") {
      return especialidadProveedor.name ?? especialidadProveedor.label ?? "";
    }

    const especialidadCatalogo = especialidades.find((esp) => normalizarId(esp.id) === normalizarId(especialidadProveedor));

    return especialidadCatalogo?.name ?? String(especialidadProveedor);
  };

  // función que se uitliza para obtener los datos de un proveedor en especifico
  const obtenerProveedor = async (prov) => {
    /*    if (
          categoria == 10 ||
          categoria == 20 ||
          categoria == 30 ||
          categoria == 40 ||
          categoria == 50 ||
          categoria == 60 ||
          categoria == 70
        ) {
          /*
              10	Hospitales ciudad de Guatemala
              20	Hospitales departamentales
              30	Centros integrales Cdad. Guatemala
              40	Farmacias
              50  OTRO
              60  OTRO
              70  OTRO
            
          setSelectedProveedor(prov);
        } else {
          apiClient
            .get(`${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/providers/${prov.id}`)
            .then((respuesta) => {
              setSelectedProveedor(
                respuesta.data.content.provider
                  ? respuesta.data.content.provider
                  : []
              );
            });
        }*/
    const nombreEspecialidad = obtenerNombreEspecialidadProveedor(prov);

    setSelectedProveedor({
      ...prov,
      specialityName: nombreEspecialidad,
    });
  };

  const especialidadSeleccionada = obtenerNombreEspecialidadProveedor(selectedProveedor);

  return (
    <Container fluid style={{ maxWidth: "95%", padding: "20px" }}>
      {/* Hero Banner */}
      <div style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=2000&q=80')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "15px",
        padding: "60px 20px",
        marginBottom: "30px",
        position: "relative",
        overflow: "hidden",
        boxShadow: "0 10px 30px rgba(0,0,0,0.15)"
      }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(10, 25, 47, 0.7)", zIndex: 1 }}></div>

        <div style={{ position: "relative", zIndex: 2, textAlign: "center", color: "#fff" }}>
          <h2 className="hero-title" style={{ fontWeight: "800", marginBottom: "15px", fontSize: "2.5rem" }}>Encuentre su Proveedor de Salud</h2>
          <p style={{ fontSize: "1.1rem", maxWidth: "700px", margin: "0 auto 40px auto", fontWeight: "300" }}>
            Acceda a nuestra amplia red de médicos, laboratorios y centros de diagnóstico  </p>

          <div className="search-container" style={{
            backgroundColor: "#fff", borderRadius: "50px", padding: "8px", display: "flex", maxWidth: "800px", margin: "0 auto", alignItems: "center", boxShadow: "0 5px 15px rgba(0,0,0,0.2)"
          }}>
            <div className="search-input-wrapper" style={{ flex: 1, display: "flex", alignItems: "center", padding: "0 20px" }}>
              <Search size={22} color="#6c757d" className="me-2" />
              <Form.Control
                type="text" placeholder="Nombre, especialidad o clínica..." value={busqueda}
                style={{ border: "none", boxShadow: "none", padding: "10px 0", fontSize: "1rem", backgroundColor: "transparent", width: "100%" }}
                onChange={(e) => setBusqueda(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') cargarProveedores(paginaActual, categoria, especialidad, pais, departamento, municipio, zona, busqueda);
                }}
              />
            </div>

            <Button
              className="search-button"
              style={{ backgroundColor: "rgb(10, 37, 88)", border: "none", borderRadius: "50px", padding: "8px 24px", fontWeight: "bold", fontSize: "0.95rem", letterSpacing: "1px" }}
              onClick={() => cargarProveedores(0, categoria, especialidad, pais, departamento, municipio, zona, busqueda)}
            >
              BUSCAR
            </Button>
          </div>
        </div>
      </div>

      {/* Categorías (Tarjetas) con Slider */}
      <div className="position-relative mb-5" style={{ padding: "0 40px", maxWidth: "100%", margin: "0 auto" }}>
        <Button
          variant="light"
          className="position-absolute start-0 top-50 translate-middle-y rounded-circle shadow-sm d-flex align-items-center justify-content-center p-0"
          style={{ width: "36px", height: "36px", zIndex: 2, border: "1px solid #dee2e6", color: "#6c757d", backgroundColor: "#fff" }}
          onClick={() => scrollCategorias('left')}
        >
          <ChevronLeft size={20} />
        </Button>

        <Button
          variant="light"
          className="position-absolute end-0 top-50 translate-middle-y rounded-circle shadow-sm d-flex align-items-center justify-content-center p-0"
          style={{ width: "36px", height: "36px", zIndex: 2, border: "1px solid #dee2e6", color: "#6c757d", backgroundColor: "#fff" }}
          onClick={() => scrollCategorias('right')}
        >
          <ChevronRight size={20} />
        </Button>

        <div ref={categoriasScrollRef} className="categorias-scroll" style={{ overflowX: "auto", paddingBottom: "10px" }}>
          <div style={{ display: "flex", gap: "15px", minWidth: "max-content", margin: "0 auto", justifyContent: "center" }}>
            {categorias.map((cat) => (
              <Card
                key={cat.id}
                onClick={() => {
                  setCategoria(cat.id); setEspecialidad(null); setCatSel(cat);
                  cargarProveedores(0, cat.id, null, pais, departamento, municipio, zona, busqueda);
                }}
                style={{
                  cursor: "pointer", width: "140px",
                  border: categoria === cat.id ? "2px solid rgb(10, 37, 88)" : "1px solid #e0e0e0",
                  backgroundColor: categoria === cat.id ? "#f4f7fb" : "#fff",
                  boxShadow: categoria === cat.id ? "0 8px 18px rgba(10, 37, 88, 0.16)" : "none",
                  transform: categoria === cat.id ? "translateY(-3px)" : "none",
                  transition: "all 0.2s ease-in-out", borderRadius: "12px",
                  position: "relative", overflow: "hidden"
                }}
                onMouseEnter={(e) => {
                  if (categoria !== cat.id) {
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.08)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (categoria !== cat.id) {
                    e.currentTarget.style.transform = "none";
                    e.currentTarget.style.boxShadow = "none";
                  }
                }}
              >
                {categoria === cat.id && (
                  <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "4px", backgroundColor: "rgb(10, 37, 88)" }} />
                )}
                <Card.Body className="d-flex flex-column align-items-center justify-content-center p-3">
                  {cat.icon ? (
                    <img src={cat.icon} alt={t(cat.name)} style={{ width: "30px", height: "30px", objectFit: "contain", marginBottom: "12px" }} />
                  ) : (
                    <Layers size={26} color="rgb(10, 37, 88)" style={{ marginBottom: "12px" }} />
                  )}
                  <Card.Text style={{ fontSize: "0.8rem", fontWeight: categoria === cat.id ? "600" : "500", color: categoria === cat.id ? "rgb(10, 37, 88)" : "#333", margin: 0, lineHeight: "1.2", textAlign: "center" }}>
                    {t(cat.name)}
                  </Card.Text>
                </Card.Body>
              </Card>
            ))}
          </div>
        </div>
      </div>

      <Row>
        {/* Sidebar Filtros */}
        <Col lg={3} className={selectedProveedor ? "d-none" : ""}>
          <div className="filters-sidebar" style={{ backgroundColor: "#fcfcfc", padding: "20px", borderRadius: "10px", border: "1px solid #ebebeb", position: "sticky", top: "20px" }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 style={{ fontWeight: "bold", margin: 0, color: "rgb(0, 52, 121)" }}>Filtros</h6>
              <span style={{ fontSize: "0.8rem", color: "#6c757d", cursor: "pointer" }} onClick={quitarFiltros}>Limpiar</span>
            </div>

            <div className="mb-4">
              <h6 style={{ fontSize: "0.75rem", fontWeight: "bold", color: "#6c757d", letterSpacing: "1px", marginBottom: "12px" }}>DEPARTAMENTO</h6>
              <div style={{ maxHeight: "200px", overflowY: "auto", paddingRight: "5px" }}>
                {departamentos.map(d => (
                  <div key={d.id} className="mb-2 d-flex align-items-center" style={{ cursor: "pointer" }} onClick={() => {
                    const isSelected = departamento?.id === d.id;
                    const opcion = isSelected ? null : { value: d.id, label: d.name, ...d };
                    setDepartamento(opcion);
                    if (isSelected) {
                      setMunicipio(null);
                      setZona(null);
                      setMunicipios([]);
                      setZonas([]);
                    }
                    cargarProveedores(0, categoria, especialidad, pais, opcion, null, null, busqueda);
                  }}>
                    <div style={{
                      width: "16px", height: "16px", borderRadius: "4px", border: "1px solid #ccc", marginRight: "10px",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      backgroundColor: departamento?.id === d.id ? "rgb(0, 52, 121)" : "white"
                    }}>
                      {departamento?.id === d.id && <div style={{ width: "8px", height: "8px", backgroundColor: "white", borderRadius: "2px" }}></div>}
                    </div>
                    <span style={{ fontSize: "0.85rem", color: "#333", fontWeight: departamento?.id === d.id ? "bold" : "normal" }}>{d.name}</span>
                  </div>
                ))}
              </div>
            </div>

            {departamento && municipios && municipios.length > 0 && (
              <div className="mb-4">
                <h6 style={{ fontSize: "0.75rem", fontWeight: "bold", color: "#6c757d", letterSpacing: "1px", marginBottom: "12px" }}>MUNICIPIO</h6>
                <div style={{ maxHeight: "200px", overflowY: "auto", paddingRight: "5px" }}>
                  {municipios.map(m => (
                    <div key={m.id} className="mb-2 d-flex align-items-center" style={{ cursor: "pointer" }} onClick={() => {
                      const isSelected = municipio?.id === m.id;
                      const opcion = isSelected ? null : { value: m.id, label: m.name, ...m };
                      setMunicipio(opcion);
                      if (isSelected) {
                        setZona(null);
                        setZonas([]);
                      }
                      cargarProveedores(0, categoria, especialidad, pais, departamento, opcion, null, busqueda);
                    }}>
                      <div style={{
                        width: "16px", height: "16px", borderRadius: "4px", border: "1px solid #ccc", marginRight: "10px",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        backgroundColor: municipio?.id === m.id ? "rgb(0, 52, 121)" : "white"
                      }}>
                        {municipio?.id === m.id && <div style={{ width: "8px", height: "8px", backgroundColor: "white", borderRadius: "2px" }}></div>}
                      </div>
                      <span style={{ fontSize: "0.85rem", color: "#333", fontWeight: municipio?.id === m.id ? "bold" : "normal" }}>{m.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {municipio && zonas && zonas.length > 0 && (
              <div className="mb-4">
                <h6 style={{ fontSize: "0.75rem", fontWeight: "bold", color: "#6c757d", letterSpacing: "1px", marginBottom: "12px" }}>ZONA</h6>
                <div style={{ maxHeight: "200px", overflowY: "auto", paddingRight: "5px" }}>
                  {zonas.map(z => (
                    <div key={z.id} className="mb-2 d-flex align-items-center" style={{ cursor: "pointer" }} onClick={() => {
                      const isSelected = zona?.id === z.id;
                      const opcion = isSelected ? null : { value: z.id, label: z.name, ...z };
                      setZona(opcion);
                      cargarProveedores(0, categoria, especialidad, pais, departamento, municipio, opcion, busqueda);
                    }}>
                      <div style={{
                        width: "16px", height: "16px", borderRadius: "4px", border: "1px solid #ccc", marginRight: "10px",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        backgroundColor: zona?.id === z.id ? "rgb(0, 52, 121)" : "white"
                      }}>
                        {zona?.id === z.id && <div style={{ width: "8px", height: "8px", backgroundColor: "white", borderRadius: "2px" }}></div>}
                      </div>
                      <span style={{ fontSize: "0.85rem", color: "#333", fontWeight: zona?.id === z.id ? "bold" : "normal" }}>{z.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {esValorActivo(CatSel?.mostrarEspecialidad) && (
              <div className="mb-4">
                <h6 style={{ fontSize: "0.75rem", fontWeight: "bold", color: "#6c757d", letterSpacing: "1px", marginBottom: "12px" }}>ESPECIALIDAD</h6>
                <div style={{ maxHeight: "200px", overflowY: "auto", paddingRight: "5px" }}>
                  {opcionesEspecialidad?.map(esp => (
                    <div key={esp.value} className="mb-2 d-flex align-items-center" style={{ cursor: "pointer" }} onClick={() => {
                      const isSelected = especialidad === esp.value;
                      const opcion = isSelected ? null : esp.value;
                      setEspecialidad(opcion);
                      cargarProveedores(0, categoria, opcion, pais, departamento, municipio, zona, busqueda);
                    }}>
                      <div style={{
                        width: "16px", height: "16px", borderRadius: "4px", border: "1px solid #ccc", marginRight: "10px",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        backgroundColor: especialidad === esp.value ? "rgb(0, 52, 121)" : "white"
                      }}>
                        {especialidad === esp.value && <div style={{ width: "8px", height: "8px", backgroundColor: "white", borderRadius: "2px" }}></div>}
                      </div>
                      <span style={{ fontSize: "0.85rem", color: "#333", fontWeight: especialidad === esp.value ? "bold" : "normal" }}>{esp.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {sessionStorage.getItem("mostrarFormularioCita") === "1" && CatSel?.mostrarFormularioCitas == true && (
              <div className="mt-4 p-3" style={{ backgroundColor: "#e8f0fe", borderRadius: "8px", border: "1px dashed rgb(0, 52, 121)" }}>
                <a className="link-style" onClick={(e) => { e.preventDefault(); setMostrarModal(true); }} style={{ cursor: "pointer", color: "rgb(0, 52, 121)", fontWeight: "bold", fontSize: "0.9rem", textDecoration: "none", display: "flex", alignItems: "center" }}>
                  <HelpCircle size={18} className="blinking-icon me-2" />
                  ¿Necesita ayuda para encontrar su proveedor?
                </a>
              </div>
            )}
          </div>
        </Col>

        {/* Main Content Area */}
        <Col lg={selectedProveedor ? 12 : 9}>
          {selectedProveedor ? (
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <strong>Detalles del proveedor</strong>
                <Button size="sm" variant="outline-danger" style={{ backgroundColor: "#872434", color: "#FFFFFF", padding: "6px 16px", fontSize: "0.9rem", borderRadius: "50px" }} onClick={() => setSelectedProveedor(null)}>
                  <ArrowLeft size={18} strokeWidth={2} className="me-1" /> Regresar
                </Button>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col md={12} className="text-center" style={{ fontSize: "1.1rem", fontWeight: "bold", color: "#003479" }}>
                    {selectedProveedor.name}
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={7}>
                    <p><Tag size={16} className="me-2" /><strong>Categoría:</strong> {obtenerNombreCategoriaProveedor(selectedProveedor) || "Sin categoría"}</p>
                    {especialidadSeleccionada && <p><Star size={16} className="me-2" /><strong>Especialidad:</strong> {especialidadSeleccionada}</p>}
                    <p><MapPin size={16} className="me-2" /><strong>Dirección:</strong> {selectedProveedor?.address}</p>
                    <p><Globe size={16} className="me-2" /><strong>País:</strong> {selectedProveedor.country?.name}</p>
                  </Col>
                  <Col md={5}>
                    <p><Landmark size={16} className="me-2" /><strong>Departamento:</strong> {selectedProveedor.department?.name}</p>
                    <p><Building2 size={16} className="me-2" /><strong>Municipio:</strong> {selectedProveedor.municipality?.name}</p>
                    <p><Layers size={16} className="me-2" /><strong>Zona:</strong> {selectedProveedor.zone?.name}</p>
                    <p><Phone size={16} className="me-2" /><strong>Teléfono:</strong> {selectedProveedor.phone || selectedProveedor.extra_phone_numbers?.join(",")}</p>
                  </Col>
                </Row>
                {selectedProveedor.latitude && selectedProveedor.longitude && (
                  <div style={{ textAlign: "center", marginTop: "15px" }}>
                    <button onClick={() => irAUbicacion(selectedProveedor.latitude, selectedProveedor.longitude)} className="btn" style={{ gap: "8px", cursor: "pointer", backgroundColor: "rgb(0, 52, 121)", color: "#FFFFFF" }}>
                      <MapPin size={20} className="me-2" /> Cómo llegar
                    </button>
                  </div>
                )}
              </Card.Body>
            </Card>
          ) : (
            <>
              {/* Encabezado de Resultados */}
              <div className="d-flex justify-content-between align-items-end mb-4">
                <div>
                  <h5 style={{ color: "rgb(0, 52, 121)", fontWeight: "bold", margin: 0 }}>
                    {CatSel ? `${t(CatSel.name)} en Guatemala` : "Proveedores en Guatemala"}
                  </h5>
                  <span style={{ color: "#6c757d", fontSize: "0.85rem" }}>Mostrando {totalRegistros} resultados encontrados</span>
                </div>
              </div>

              {/* Grid de Tarjetas */}
              {CatSel?.id == 40 ? (
                <Farmacias listaFarmacia={lstFarmacias} />
              ) : proveedores.length === 0 ? (
                <div className="text-center p-5" style={{ backgroundColor: "#f8f9fa", borderRadius: "10px" }}>
                  <h5 style={{ color: "#6c757d" }}>Sin resultados encontrados</h5>
                </div>
              ) : (
                <Row className="g-4">
                  {proveedores.map((prov, index) => (
                    <Col md={12} xl={6} key={index}>
                      <Card className="h-100 shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                        <Card.Body className="p-4 d-flex flex-column">
                          <div className="d-flex align-items-start mb-3">
                            <div style={{
                              width: "48px", height: "48px", borderRadius: "10px", backgroundColor: "rgba(0, 52, 121, 0.05)",
                              display: "flex", alignItems: "center", justifyContent: "center", marginRight: "15px", flexShrink: 0
                            }}>
                              <Building2 size={24} color="rgb(0, 52, 121)" />
                            </div>
                            <div>
                              {normalizarId(prov.category) === "3" && <span style={{ fontSize: "0.65rem", fontWeight: "bold", backgroundColor: "#e8f0fe", padding: "2px 6px", color: "rgb(0, 52, 121)", padding: "3px 8px", borderRadius: "20px", display: "inline-block", marginBottom: "5px" }}>Afiliado</span>}
                              <h6 style={{ fontWeight: "bold", fontSize: "0.95rem", margin: 0, color: "#333", lineHeight: "1.3" }}>{prov.name}</h6>
                               <div style={{ fontSize: "0.75rem", color: "rgb(135, 36, 52)", fontWeight: "bold", marginTop: "4px" }}>
                                {obtenerNombreCategoriaProveedor(prov)?.toUpperCase() || ""}
                              </div>
                              <div style={{ fontSize: "0.75rem", color: "rgb(135, 36, 52)", fontWeight: "bold", marginTop: "4px" }}>
                                 {obtenerNombreEspecialidadProveedor(prov)?.toUpperCase() || ""}
                                  </div>
                              <div className="mt-1 d-flex align-items-center" style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                                <MapPin size={14} className="me-1" />
                                {prov.department?.name || prov.municipality?.name}, Zona {prov.zone?.name || ""}
                              </div>
                            </div>
                          </div>

                          <Row className="mt-auto mb-3 g-2">
                            <Col xs={6}>
                              <div style={{ fontSize: "0.65rem", color: "#999", letterSpacing: "1px" }}>DIRECCIÓN</div>
                              <div style={{ fontSize: "0.8rem", color: "#333", display: "-webkit-box", WebkitLineClamp: "2", WebkitBoxOrient: "vertical", overflow: "hidden" }}>{prov.address}</div>
                            </Col>
                            <Col xs={6}>
                              <div style={{ fontSize: "0.65rem", color: "#999", letterSpacing: "1px" }}>CONTACTO</div>
                              <div style={{ fontSize: "0.8rem", color: "#333", fontWeight: "500" }}>{prov.phone || prov.extra_phone_numbers?.join(",")}</div>
                            </Col>
                          </Row>

                          <Button
                            className="w-100 mt-2"
                            style={{ backgroundColor: "rgb(0, 52, 121)", borderColor: "rgb(0, 52, 121)", fontWeight: "bold", padding: "6px 12px", fontSize: "0.8rem", borderRadius: "6px" }}
                            onClick={() => obtenerProveedor(prov)}
                          >
                            VER PERFIL
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              )}

              {/* Paginación */}
              {!selectedProveedor && proveedores.length > 0 && CatSel?.id != 40 && (
                <div className="mt-4 mb-5 d-flex justify-content-center">
                  {renderPaginacion()}
                </div>
              )}
            </>
          )}
        </Col>
      </Row>

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "#fbfbfb",
            opacity: 0.95,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            flexDirection: "column",
          }}
        >
          <img
            src={loadingGif}
            alt="Cargando..."
            style={{
              width: "300px",
              maxWidth: "90%",
              animation: "fadeInOut 2s infinite",
            }}
          />
          <div className="mt-3 text-white">Cargando...</div>
        </div>
      )}
      <RedProvFormularioModal show={mostrarModal} onClose={cerrarModalFom} />

      <style>
        {`
    .blinking-icon {
      animation: blink 1s infinite;
    }

    @keyframes blink {
      0%, 100% { opacity: 1; }
      50% { opacity: 0; }
    }

    .link-style {
      color: rgb(135, 36, 52);
      cursor: pointer;
      text-decoration: underline;
      font-size: 19px;
      font-weight: bold;
      margin-bottom:15px;
    }
      .link-style2 {
      color: rgb(0, 52, 121);
      cursor: pointer;
      text-decoration: underline;
      font-size: 19px;
      font-weight: bold;
      margin-bottom:15px;
    }

    .link-style:hover {
      color: rgb(0, 52, 121);
      text-decoration: none;
    }
      .link-style2:hover {
      color: rgb(135, 36, 52);
      text-decoration: none;
    }
    
    /* Scrollbar invisible para tarjetas */
    .categorias-scroll::-webkit-scrollbar {
      display: none;
    }
    .categorias-scroll {
      -ms-overflow-style: none;
      scrollbar-width: none;
      scroll-behavior: smooth;
    }
    
    /* Responsive Media Queries */
    @media (max-width: 768px) {
      .search-container {
        flex-direction: column !important;
        border-radius: 15px !important;
        padding: 15px !important;
      }
      .search-input-wrapper {
        margin-bottom: 15px;
        width: 100%;
      }
      .search-button {
        width: 100%;
        border-radius: 10px !important;
      }
      .hero-title {
        font-size: 1.8rem !important;
      }
      .filters-sidebar {
        position: static !important;
        margin-bottom: 20px;
      }
    }
  `}
      </style>
    </Container>
  );
};

export default RedProveedores;
